var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 15.172L19.1917 5.979L20.6067 7.393L9.99974 18L3.63574 11.636L5.04974 10.222L9.99974 15.172Z",
    fill: "#3796F6"
  })));
};

export default __webpack_public_path__ + "static/media/check-mark.97c249a7.svg";
export { SvgComponent as ReactComponent };